import { render, staticRenderFns } from "./_base-multiselect.vue?vue&type=template&id=73d6008d"
import script from "./_base-multiselect.vue?vue&type=script&lang=js"
export * from "./_base-multiselect.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./_base-multiselect.vue?vue&type=style&index=1&id=73d6008d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports